var CameraError = /* @__PURE__ */ function(CameraError2) {
  CameraError2["Cancel"] = "User cancelled photos app";
  CameraError2["PermissionApiUnavailable"] = "Permissions API not available in this browser";
  CameraError2["PermissionCameraUnavailable"] = "Camera permissions are not available in this browser";
  CameraError2["ImageLoadFailure"] = "Error loading image";
  CameraError2["ImageConversionFailure"] = "Unable to convert image to jpeg";
  CameraError2["PathNotAvailable"] = "Unable to get portable path to file";
  CameraError2["CameraUnavailableSimulator"] = "Camera not available while running in Simulator";
  CameraError2["PermissionCameraDenied"] = "User denied access to camera";
  CameraError2["PermissionPhotosDenied"] = "User denied access to photos";
  CameraError2["ImageSaveError"] = "Unable to create photo on disk";
  CameraError2["InvalidResultType"] = "Invalid resultType option";
  CameraError2["CameraUnavailable"] = "Device doesn't have a camera available";
  CameraError2["CameraNoActivity"] = "Unable to resolve camera activity";
  CameraError2["PhotoNoActivity"] = "Unable to resolve photo activity";
  CameraError2["ImageProcessMissingFailure"] = "Unable to process image, file not found on disk";
  CameraError2["ImageProcessFailure"] = "Unable to process image";
  CameraError2["ImageEditError"] = "Unable to edit image";
  return CameraError2;
}({});

export { CameraError };
//# sourceMappingURL=mediaRecording.types.js.map
